"use strict";
const stylesMap = {};
let elementsToBeTruncated = [];
let hiddenElementsShown = [];
let elCount = 0;
let defaultBrowserLineHeight;

//since style objects from getComputedStyle are live and change accordingly
//its wise to save them, especially since every call to getComputedStyle triggers a
//reflow
const getStyle = function(el) {
  if (!el.dataset.styleId) {
    do {
      el.dataset.styleId = Math.random();
    } while (stylesMap[el.dataset.styleId]);
    stylesMap[el.dataset.styleId] = window.getComputedStyle(el);
  }
  return stylesMap[el.dataset.styleId];
};

const calculateDefaultBrowserLineHeight = function() {
  if (defaultBrowserLineHeight) return defaultBrowserLineHeight;
  elementsToBeTruncated.some(elObj => {
    let el = elObj.el;
    let tempHtml = el.innerHTML;
    el.innerHTML = "A";
    let originalLineHeight = el.style.lineHeight;
    el.style.lineHeight = "normal";
    let style = getStyle(el);
    let height = parseInt(style.getPropertyValue("height")) || el.offsetHeight;
    let box_sizing = style.getPropertyValue("box-sizing");
    let font_size = parseInt(style.getPropertyValue("font-size"));
    if (box_sizing === "border-box") {
      let padding_top = parseInt(style.getPropertyValue("padding-top"));
      let padding_bottom = parseInt(style.getPropertyValue("padding-bottom"));
      let border_top = parseInt(style.getPropertyValue("border-top-width"));
      let border_bottom = parseInt(
        style.getPropertyValue("border-bottom-width")
      );
      height =
        height - padding_top - padding_bottom - border_top - border_bottom;
    }
    el.innerHTML = tempHtml;
    el.style.lineHeight = originalLineHeight;
    if (height) {
      defaultBrowserLineHeight = height / font_size;
    }
    return defaultBrowserLineHeight;
  });
};

const countLines = function(el) {
  let style = getStyle(el);
  let height = parseInt(style.getPropertyValue("height"));
  let font_size = parseInt(style.getPropertyValue("font-size"));
  let line_height = parseInt(style.getPropertyValue("line-height"));
  let box_sizing = style.getPropertyValue("box-sizing");

  if (isNaN(line_height)) {
    line_height = defaultBrowserLineHeight * font_size;
  }

  if (isNaN(height) && !findHiddenElement(el)){
    height = el.offsetHeight
  }

  if (box_sizing === "border-box") {
    let padding_top = parseInt(style.getPropertyValue("padding-top"));
    let padding_bottom = parseInt(style.getPropertyValue("padding-bottom"));
    let border_top = parseInt(style.getPropertyValue("border-top-width"));
    let border_bottom = parseInt(style.getPropertyValue("border-bottom-width"));
    height = height - padding_top - padding_bottom - border_top - border_bottom;
  }
  return Math.floor(height / line_height);
};

const findHiddenElement = function(el) {
  let currentNode = el;
  let style;
  while (currentNode) {
    if (currentNode.style.display === "none") {
      return currentNode;
    } else {
      style = getStyle(currentNode);
      if (style.display === "none") {
        return currentNode;
      }
    }
    currentNode = currentNode.parentElement;
  }
  return null;
};

const toggleElementTruncation = function(event) {
  event.stopPropagation();
  let el = event.target;
  while (el && !el.dataset.expanded) {
    el = el.parentElement;
  }
  if (el.dataset.expanded === "true") {
    el.innerHTML = el.dataset.truncatedHtml;
    el.dataset.expanded = "false";
  } else {
    el.innerHTML = el.dataset.notTruncated;
    el.dataset.expanded = "true";
  }
};

const truncateEls = function() {
  let hiddenElement;
  let originalDisplay;
  calculateDefaultBrowserLineHeight();
  elementsToBeTruncated = elementsToBeTruncated.filter(elObj => {
    let el = elObj.el;
    let binding = elObj.binding;
    let numOfLines = countLines(el);
    let maxNumOfLines = binding.value.maxLines;
    if(!maxNumOfLines){
      return false
    }
    elObj.maxNumOfLines = maxNumOfLines;

    if (isNaN(numOfLines)) {
      hiddenElement = findHiddenElement(el);
      if (!hiddenElement) {
        console.error("problem in text truncate, cannot find hidden element.");
        return false;
      }
      originalDisplay = hiddenElement.style.display;
      hiddenElement.style.display = "initial";
      if (hiddenElement.style.display !== "initial") {
        //internet explorer does not like initial
        hiddenElement.style.display = "";
      }
      hiddenElementsShown.push({ hiddenElement, originalDisplay });
      numOfLines = countLines(el);
      if (isNaN(numOfLines)) {
        console.error(
          "problem in text truncate, cannot set visibility of hidden element."
        );
        return false;
      }
    }
    elObj.numOfLines = numOfLines;
    return numOfLines > maxNumOfLines;
  });
  elementsToBeTruncated.forEach(elObj => {
    let originalHTML = elObj.el.innerHTML;
    elObj.originalHTML = originalHTML;
    elObj.portion = 1 / 2;
    elObj.currLength = Math.floor(originalHTML.length * elObj.portion);
    elObj.maxIterations = Math.ceil(Math.log2(originalHTML.length));
    elObj.truncStr = elObj.binding.value.expandable
      ? ` <span style=" color: rgb(47,104,186); ">${elObj.vnode.context.$t(
          "common.words.show_more"
        )}</span>`
      : "...";
    elObj.bestAproximation = 0;
  });
  let i = 1;
  let numOfLines;
  let maxNumOfLines;
  let originalHTML;
  let bestAproximation;
  let el;
  let truncStr;
  let currLength;
  let maxIterations;
  let binding;
  while (elementsToBeTruncated.length > 0) {
    i++;
    elementsToBeTruncated.forEach(elObj => {
      elObj.currLength = Math.floor(elObj.originalHTML.length * elObj.portion);
      elObj.el.innerHTML = `${elObj.originalHTML.substring(
        0,
        elObj.currLength
      )}${elObj.truncStr} `;
    });
    let elementsToCheck = elementsToBeTruncated.filter(elObj => {
      elObj.numOfLines = countLines(elObj.el);
      return elObj.numOfLines === elObj.maxNumOfLines;
    });
    elementsToCheck.forEach(elObj => {
      originalHTML = elObj.originalHTML;
      el = elObj.el;
      truncStr = elObj.truncStr;
      currLength = elObj.currLength;
      el.innerHTML = `${originalHTML.substring(0, currLength + 1)}${truncStr} `;
    });
    elementsToCheck = elementsToCheck.filter(elObj => {
      el = elObj.el;
      maxNumOfLines = elObj.maxNumOfLines;
      return countLines(el) > maxNumOfLines;
    });
    elementsToCheck.forEach(elObj => {
      numOfLines = elObj.numOfLines;
      maxNumOfLines = elObj.maxNumOfLines;
      originalHTML = elObj.originalHTML;
      el = elObj.el;
      truncStr = elObj.truncStr;
      currLength = elObj.currLength;
      binding = elObj.binding;
      el.innerHTML = `${originalHTML.substring(0, currLength)}${truncStr} `;
      if (binding.value.expandable) {
        el.dataset.expanded = false;
        el.dataset.notTruncated = `${originalHTML} <span style=" color: rgb(47,104,186); ">${elObj.vnode.context.$t(
          "common.words.show_less"
        )}</span> `;
        el.dataset.truncatedHtml = el.innerHTML;
        el.style.cursor = "pointer";
        el.addEventListener("click", toggleElementTruncation);
      }
      elementsToBeTruncated.splice(elementsToBeTruncated.indexOf(elObj), 1);
    });

    elementsToBeTruncated = elementsToBeTruncated.filter(elObj => {
      numOfLines = elObj.numOfLines;
      maxNumOfLines = elObj.maxNumOfLines;
      originalHTML = elObj.originalHTML;
      bestAproximation = elObj.bestAproximation;
      el = elObj.el;
      truncStr = elObj.truncStr;
      currLength = elObj.currLength;
      maxIterations = elObj.maxIterations;
      binding = elObj.binding;
      if (numOfLines > maxNumOfLines) {
        elObj.portion -= 1 / 2 ** i;
      } else {
        elObj.bestAproximation = Math.max(currLength, bestAproximation);
        elObj.portion += 1 / 2 ** i;
      }
      if (
        i > maxIterations * 2 ||
        currLength > originalHTML.length ||
        currLength === 0
      ) {
        if (bestAproximation) {
          el.innerHTML = `${originalHTML.substring(
            0,
            bestAproximation
          )}${truncStr} `;
          if (binding.value.expandable) {
            el.dataset.expanded = false;
            el.dataset.notTruncated = `${originalHTML} <span style=" color: rgb(47,104,186); ">${elObj.vnode.context.$t(
              "common.words.show_less"
            )}</span> `;
            el.dataset.truncatedHtml = el.innerHTML;
            el.style.cursor = "pointer";
            el.addEventListener("click", toggleElementTruncation);
          }
          console.warn(
            "problem in text truncate, make sure parent container width is bounded. resorting to an approximation."
          );
        } else {
          el.innerHTML = originalHTML;
          console.error(
            "problem in text truncate, make sure parent container width is bounded."
          );
          console.log(el);
        }
        return false;
      }
      return true;
    });
  }
  hiddenElementsShown.forEach(elObj => {
    elObj.hiddenElement.style.display = elObj.originalDisplay;
  });
  hiddenElementsShown.length = 0;
};

export default {
  bind: function(el, binding, vnode) {
    elCount++;
  },
  inserted: function(el, binding, vnode) {
    //by truncating all elements together and grouping DOM invalidations and measurements
    //together thus reducing reflows, the total run time of
    //of mass truncation was cut by more than 75% (200+ ms to approximatly 50ms ) in some cases
    //good read https://pagebuildersandwich.com/increased-plugins-performance-200/
    elCount--;
    elementsToBeTruncated.push({ el, binding, vnode });

    if (elCount === 0) {
      truncateEls();
    }
  },
  unbind: function(el, binding, vnode) {
    if (el.dataset.truncatedHtml)
      el.removeEventListener("click", toggleElementTruncation);
    stylesMap[el.dataset.styleId] = null;
  }
};
